import DOMPurify from "dompurify";

export class LoginManager {
    constructor(private containerElement: JQuery) { }

    private loginForm : JQuery<HTMLElement>;
    private submitButton : JQuery<HTMLElement>;

    public initialize() {
        var self = this;

        self.loginForm = self.containerElement.find('#login-form');
        self.submitButton = self.loginForm.find('button[type="submit"]');

        self.initializeForm();

        (<any>window).initializeLogin = () => {
            self.initializeForm();
        }
    }

    private initializeForm() {
        var self = this;

        self.loginForm.off('submit').on('submit', (e) => {
            self.submitButton.prop('disabled', true);
            self.loginForm.find(':input').each((index, element) => {
                var formElement = $(element);
                var formElementValue = formElement.val();

                if(formElementValue != undefined) {
                    formElement.val(DOMPurify.sanitize(formElementValue.toString()));
                }
            })
        })
    }
}